/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Sync_FailedInputs */

const en_history_sync_failed = /** @type {(inputs: History_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync failed`)
};

/**
* | output |
* | --- |
* | "Sync failed" |
*
* @param {History_Sync_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const history_sync_failed = /** @type {((inputs?: History_Sync_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Sync_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_history_sync_failed(inputs)
});